import { KoobInputSelect } from '@koob/ui';
import { useApp } from 'hooks';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { decodeId } from 'utils';

export function useNightRatesOrganizations(rooms) {
  const { t } = useTranslation('allotments');
  const { currentOrganizationId } = useApp();
  const dmcOrganizationId = decodeId(currentOrganizationId);

  const organizations = useMemo(() => {
    const orgsMap = new Map();

    // Always seed with the DMC org so a user who selects a TO can always
    // switch back — even when no periodOrganization references the DMC.
    if (dmcOrganizationId) {
      orgsMap.set(dmcOrganizationId, {
        label: t('modal.dmc'),
        value: dmcOrganizationId,
        isDmc: true,
      });
    }

    if (rooms && Array.isArray(rooms)) {
      rooms.forEach((room) => {
        (room?.periods ?? []).forEach((period) => {
          (period?.periodOrganizations ?? []).forEach((periodOrg) => {
            const org = periodOrg?.organization;
            if (!org?.id) return;
            const id = decodeId(org.id);
            if (!id || orgsMap.has(id)) return;
            orgsMap.set(id, {
              label: org.displayName ?? org.name ?? id,
              value: id,
              isDmc: false,
            });
          });
        });
      });
    }

    return Array.from(orgsMap.values());
  }, [rooms, dmcOrganizationId, t]);

  return { organizations, dmcOrganizationId };
}

function NightRatesOrganizationSelector({
  rooms,
  organizationId,
  setOrganizationId,
}) {
  const { t } = useTranslation('allotments');
  const { organizations, dmcOrganizationId } =
    useNightRatesOrganizations(rooms);

  return (
    <div>
      <KoobInputSelect
        value={organizationId ?? dmcOrganizationId}
        onValueChange={(value) => setOrganizationId(parseInt(value, 10))}
        options={organizations}
        placeholder={t('modal.dmc')}
        disabled={organizations.length === 0}
      />
    </div>
  );
}

export default NightRatesOrganizationSelector;
